import { Link } from "react-router-dom";

export function Container({ children, className = "" }) {
  return <div className={`max-w-5xl mx-auto px-5 py-8 md:px-10 md:py-12 ${className}`}>{children}</div>;
}

export function PageHeader({ eyebrow, title, subtitle }) {
  return (
    <div className="mb-8 fade-up">
      {eyebrow && <p className="text-gold text-xs uppercase tracking-[0.2em] mb-3">{eyebrow}</p>}
      <h1 className="font-display text-3xl md:text-4xl tracking-tight font-light">{title}</h1>
      {subtitle && <p className="text-white/40 mt-2 max-w-2xl">{subtitle}</p>}
    </div>
  );
}

export function Spinner({ label }) {
  return (
    <div className="flex items-center gap-3 text-white/50 text-sm py-6">
      <div className="w-5 h-5 rounded-full border-2 border-white/10 border-t-[#D4AF37] animate-spin" />
      {label || "Génération en cours..."}
    </div>
  );
}

export function PaywallNotice() {
  return (
    <div data-testid="paywall-notice" className="mt-4 rounded-xl border border-gold/30 bg-gradient-to-r from-[#BF953F]/15 to-transparent p-4 flex items-center justify-between gap-4">
      <p className="text-sm text-white/80">Passe à Premium pour débloquer toutes les fonctionnalités.</p>
      <Link to="/premium" data-testid="paywall-cta"
        className="shrink-0 gold-gradient text-black rounded-full px-4 py-1.5 text-sm font-medium">Premium</Link>
    </div>
  );
}

export function GenerateButton({ children, className = "", ...props }) {
  return (
    <button {...props}
      className={`inline-flex items-center justify-center gap-2 gold-gradient text-black rounded-full px-6 py-2.5 font-medium hover:opacity-90 transition-opacity disabled:opacity-40 disabled:cursor-not-allowed ${className}`}>
      {children}
    </button>
  );
}
